module.exports = __webpack_public_path__ + "img/monitor.6f53d2e3.png";